import React from 'react'
import * as firebase from 'firebase'

import _ from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'

import JobModuleBase from '../JobModuleBase'
import MaterialItem from './MaterialItem'
import MaterialAddItem from './MaterialAddItem'
import AllMaterialsScreen from './AllMaterialsScreen'
import Analytics from 'infra/analytics/Analytics'

class MaterialsModule extends JobModuleBase {

  constructor(props) {
    super(props)
    this.state = {
      // View mode is 'view' or 'add'
      mode: 'view',
      materials: {},
      materialsDataSource: this.getMaterialsDataSource(this.props),
      expandedIndex: null
    }
  }

  componentWillMount() {
    // Only query materials for the day being.
    firebase.database()
      .ref(this.getJobMaterialsListDbPath())
      .orderByChild('jobDateStr')
      .equalTo(this.props.dateStr)
      .on('value', this.onUpdate)
  }

  componentWillUnmount() {
    firebase.database()
      .ref(this.getExtendedModulesDbPath())
      .off('value', this.onUpdate)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.defaultMaterials !== nextProps.defaultMaterials) {
      this.setState({ materialsDataSource: this.getMaterialsDataSource(nextProps) })
    }
  }

  getMaterialsDataSource = props => {
    const value = props.defaultMaterials
    const materialsDataSource = value
      ? _.map(value)
      : []
    return materialsDataSource
  }

  onUpdate = snapshot => {
    let value = snapshot && snapshot.val()
    const materials = value || {}
    this.setState({ materials })
  }

  getJobMaterialsListDbPath = () => {
    return `${this.getExtendedModulesDbPath()}/list`
  }

  handleAddMaterial = event => {
    event.preventDefault()
    this.setState({ mode: 'add' })
  }

  handleSave = newMaterial => {
    const dbList = firebase.database()
      .ref(this.getJobMaterialsListDbPath())
    const key = dbList.push().key
    dbList.child(key).set({
      id: key,
      name: newMaterial.name,
      creationDate: newMaterial.creationDate
        ? newMaterial.creationDate :
        moment().format('YYYY-MM-DD HH:mm:ss'),
      jobDateStr: this.props.dateStr,
      cost: newMaterial.cost ? newMaterial.cost : '',
      quantity: newMaterial.quantity ? newMaterial.quantity : '',
      units: newMaterial.units ? newMaterial.units : '',
      store: newMaterial.store ? newMaterial.store : '',
      reimbursed: newMaterial.reimbursed ? newMaterial.reimbursed : false,
      billable: newMaterial.billable ? newMaterial.billable : false,
      notes: newMaterial.notes ? newMaterial.notes : '',
      userId: this.props.userMetadata ? this.props.userMetadata.id : '',
    })
    this.setState({ mode: 'view' })
    Analytics.track(Analytics.MATERIALS_ADDED)
  }

  handleCancel = () => {
    this.setState({ mode: 'view' })
  }

  onRowSelection = (expandedIndex) => {
    if (expandedIndex === this.state.expandedIndex){
      this.setState({ expandedIndex: null})
    } else {
      this.setState({ expandedIndex })
    }
  }

  renderMaterials() {
    const views = []
    let index = 0
    for (const key in this.state.materials) {
      const material = this.state.materials[key]
      if (!material.delete) {
        views.push(
          <MaterialItem
            key={key}
            index={index}
            expanded={this.state.expandedIndex === index}
            onPress={this.onRowSelection.bind(this, index)}
            material={material}/>
        )
        index++
      }
    }

    return (
      <div>
        <div style={styles.listHeaderContainer}>
          <div style={{ ...styles.iconHeader, ...styles.listSelectWidth }}></div>
          <div style={{ ...styles.listHeader, ...styles.listMainWidth }}>Item</div>
          <div style={{ ...styles.listHeader, ...styles.listMinorWidth }}>Quantity</div>
          <div style={{ ...styles.listHeader, ...styles.listMinorWidth }}>Cost (per unit)</div>
          <div style={{ ...styles.listHeader, ...styles.listMinorWidth }}>Cost (total)</div>
          <div style={{ ...styles.listHeader, ...styles.listMinorWidth }}>Used On</div>
        </div>
        { views }
      </div>
    )
  }

  render() {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'column' }}>
        { this.renderMaterials() }
        {/* Show the footer action to be 'Add material' text or the new material input component */}
        <div style={styles.footer}>
          { this.state.mode === 'view'
            ? <div style={styles.addMaterial} onTouchTap={this.handleAddMaterial}>Add material ...</div>
            : <MaterialAddItem
              materialsDataSource={this.state.materialsDataSource}
              style={{ marginTop: 8, marginBottom: 8 }}
              onCancel={this.handleCancel}
              onSave={this.handleSave} />
          }
        </div>
        <AllMaterialsScreen
          open={this.props.openShowAllMaterialsScreen}
          jobName={this.props.jobInfo.modules.displayName.value}
          materialsListDbPath={this.getJobMaterialsListDbPath()}
          onRequestClose={this.props.onRequestClose} />
      </div>
    )
  }

}

const styles = {

  header: {
    color: '#757575',
    fontWeight: 500,
    fontSize: 14,
    paddingLeft: 14,
    paddingRight: 14
  },

  footer: {
    marginTop: 8
  },

  addMaterial: {
    cursor: 'pointer',
    color: '#356992',
    fontSize: 14,
    paddingTop: 8
  },

  listHeader: {
    color: '#757575',
    fontWeight: 500,
    fontSize: 14,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 8
  },

  iconHeader: {
    paddingLeft: 16,
    paddingBottom: 8
  },

  listHeaderContainer: {
    display:'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #527da3'
  },

  listMainWidth: {
    width: 200
  },

  listMinorWidth: {
    width: 100
  },

  listSelectWidth: {
    width: 16
  },

  row: {
    borderBottom: '1px solid #527da3'
  }

}

const mapStateToProps = state => ({
  userMetadata: state.firebase.user.metadata.value,
  teamId: state.firebase.team.metadata.value.id,
  defaultMaterials: state.firebase.team.defaultMaterials.value
})

export default connect(mapStateToProps)(MaterialsModule)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/materials/MaterialsModule.js